let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jlidQ")).then(() => parcelRequire('ei5Sx'));